import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import { pickHTMLProps } from 'pick-react-known-prop';
import useTranslate from '@sprinx/react-globalize/useTranslate';
import ProductImageDecorated from '../ProductImageDecorated';
import ProductImageGalleryThumbnails from '../ProductImageGalleryThumbnails';
import ProductImageModal from '../ProductImageModal';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      '&$variant-horizontal': {
        flexDirection: 'column',
        alignItems: 'center'
      },
      '&$variant-vertical': {
        flexDirection: 'row'
      }
    },
    image: {
      height: 250,
      width: 250,
      display: 'flex'
    },
    'variant-horizontal': {},
    'variant-horizontal-image': {
      alignItems: 'center'
    },
    'variant-vertical': {},
    'variant-vertical-image': {
      justifyContent: 'center'
    },
    'un-defined': {
      background: theme.palette.grey[100],
      color: theme.palette.grey[300],
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%'
    }
  };
}, {
  name: 'SxComProductImageGallery'
});

var _ref2 = /*#__PURE__*/React.createElement(PhotoCameraIcon, {
  color: "inherit"
});

function ProductImageGallery(_ref) {
  var adornments = _ref.adornments,
      pClasses = _ref.classes,
      className = _ref.className,
      ImageGalleryThumbnailsProps = _ref.ImageGalleryThumbnailsProps,
      product = _ref.product,
      _ref$PrimaryImageComp = _ref.PrimaryImageComponent,
      PrimaryImageComponent = _ref$PrimaryImageComp === void 0 ? ProductImageDecorated : _ref$PrimaryImageComp,
      PrimaryImageProps = _ref.PrimaryImageProps,
      mediaTypeComponents = _ref.mediaTypeComponents,
      ThumbnailsComponent = _ref.ThumbnailsComponent,
      ProductImageModalProps = _ref.ProductImageModalProps,
      visibleThumbnailsLimit = _ref.visibleThumbnailsLimit,
      openModalOnThumbnailClick = _ref.openModalOnThumbnailClick,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, ["adornments", "classes", "className", "ImageGalleryThumbnailsProps", "product", "PrimaryImageComponent", "PrimaryImageProps", "mediaTypeComponents", "ThumbnailsComponent", "ProductImageModalProps", "visibleThumbnailsLimit", "openModalOnThumbnailClick", "variant"]);

  var classes = useStyles({
    classes: pClasses,
    className: className
  });
  var t = useTranslate();

  var _React$useMemo = React.useMemo(function () {
    var image = product.image,
        name = product.name,
        _product$media = product.media,
        media = _product$media === void 0 ? [] : _product$media;
    if (!image && !media.length) return [[]];
    var imgd = image ? {
      src: image,
      alt: name,
      type: 'image',
      index: 0
    } : {};
    return [[imgd].concat(_toConsumableArray(media)).filter(function (i) {
      return !!i.src;
    }).map(function (i, index) {
      return _extends({
        index: index
      }, i);
    }), name];
  }, [product]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
      allMedia = _React$useMemo2[0],
      defaultAlt = _React$useMemo2[1];

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeMediaIndex = _React$useState2[0],
      setActiveMediaIndex = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      open = _React$useState4[0],
      setOpen = _React$useState4[1];

  var handleOpenGallery = React.useCallback(function (value) {
    return function () {
      return setOpen(value);
    };
  }, [setOpen]);
  var handleSetActiveMediaIndex = React.useCallback(function (v) {
    setActiveMediaIndex(v);

    if (openModalOnThumbnailClick) {
      setOpen(true);
    }
  }, [openModalOnThumbnailClick]);
  React.useEffect(function () {
    setActiveMediaIndex(0);
    handleOpenGallery(false);
  }, [handleOpenGallery, product]);
  var activeMedia = allMedia[activeMediaIndex] || allMedia[0];
  return /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, classes["variant-".concat(variant)], className)
  }), allMedia.length && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx(classes["variant-".concat(variant, "-image")], classes.image)
  }, /*#__PURE__*/React.createElement(PrimaryImageComponent, _extends({
    size: "big"
  }, adornments, {
    active: true,
    alt: activeMedia.alt || defaultAlt,
    src: activeMedia.src,
    stream: activeMedia.stream,
    type: activeMedia.type,
    onClick: handleOpenGallery(true),
    style: {
      cursor: 'pointer'
    }
  }, PrimaryImageProps))), /*#__PURE__*/React.createElement(ProductImageGalleryThumbnails, _extends({
    activeMediaIndex: activeMediaIndex,
    altDefault: defaultAlt,
    media: allMedia,
    variant: variant,
    onChange: handleSetActiveMediaIndex,
    visibleThumbnailsLimit: visibleThumbnailsLimit,
    mediaTypeComponents: mediaTypeComponents
  }, ImageGalleryThumbnailsProps)), /*#__PURE__*/React.createElement(ProductImageModal, _extends({
    activeMediaIndex: activeMediaIndex,
    allMedia: allMedia,
    open: open,
    defaultAlt: defaultAlt,
    variant: variant,
    onClose: handleOpenGallery(false),
    thumbnailModalSize: 'small',
    mediaTypeComponents: mediaTypeComponents
  }, ProductImageModalProps))), allMedia.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: classes['un-defined'],
    title: t('com/productDetailImageGallery/noImage')
  }, _ref2));
}

ProductImageGallery.propTypes = {
  adornments: PropTypes.shape({
    adornmentAsideLeft: PropTypes.node,
    adornmentAsideRight: PropTypes.node,
    adornmentInsideBottomLeft: PropTypes.node,
    adornmentInsideBottomRight: PropTypes.node,
    adornmentInsideTopLeft: PropTypes.node,
    adornmentInsideTopRight: PropTypes.node
  }),
  classes: PropTypes.shape({
    gallery: PropTypes.string,
    galleryItem: PropTypes.string,
    gridPlacement: PropTypes.string,
    image: PropTypes.string,
    root: PropTypes.string,
    'un-defined': PropTypes.string,
    'variant-horizontal': PropTypes.string,
    'variant-horizontal-image': PropTypes.string,
    'variant-vertical': PropTypes.string,
    'variant-vertical-image': PropTypes.string
  }),
  className: PropTypes.string,
  ImageGalleryThumbnailsProps: PropTypes.shape({}),
  mediaTypeComponents: PropTypes.shape({}),
  openModalOnThumbnailClick: PropTypes.bool,
  PrimaryImageComponent: PropTypes.elementType,
  PrimaryImageProps: PropTypes.shape({// shape: PropTypes.oneOf(['square', 'landscape', 'portrait', 'wide', 'tall']),
    // shrink: PropTypes.oneOf(['crop', 'fit']),
    // size: PropTypes.oneOf(['mini', 'small', 'normal', 'big']),
  }),
  product: PropTypes.shape({
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))]),
    media: PropTypes.arrayOf(PropTypes.shape({
      alt: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.shape({
        language: PropTypes.string.isRequired,
        text: PropTypes.string
      }))]),
      src: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))]).isRequired,
      stream: PropTypes.string,
      type: PropTypes.string
    })),
    name: PropTypes.arrayOf(PropTypes.shape({
      language: PropTypes.string.isRequired,
      text: PropTypes.string
    }))
  }).isRequired,
  ProductImageModalProps: PropTypes.shape({}),
  ThumbnailsComponent: PropTypes.elementType,
  variant: PropTypes.oneOf(['vertical', 'horizontal']),
  visibleThumbnailsLimit: PropTypes.number
};
ProductImageGallery.defaultProps = {
  adornments: undefined,
  classes: undefined,
  className: undefined,
  ImageGalleryThumbnailsProps: undefined,
  mediaTypeComponents: undefined,
  openModalOnThumbnailClick: false,
  PrimaryImageComponent: undefined,
  PrimaryImageProps: undefined,
  ProductImageModalProps: undefined,
  ThumbnailsComponent: undefined,
  variant: 'horizontal',
  visibleThumbnailsLimit: 3
};
export default ProductImageGallery;